<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7.69143" cy="7.69143" r="3.69143" :fill="fill" />
    <circle cx="16.9199" cy="7.69143" r="3.69143" :fill="fill" />
    <circle cx="26.1485" cy="7.69143" r="3.69143" :fill="fill" />
    <circle cx="7.69143" cy="16.92" r="3.69143" :fill="fill" />
    <circle cx="16.9199" cy="16.92" r="3.69143" :fill="fill" />
    <circle cx="26.1485" cy="16.92" r="3.69143" :fill="fill" />
    <circle cx="7.69143" cy="26.1486" r="3.69143" :fill="fill" />
    <circle cx="16.9199" cy="26.1486" r="3.69143" :fill="fill" />
    <circle cx="26.1485" cy="26.1486" r="3.69143" :fill="fill" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 34,
    },
    height: {
      type: Number,
      default: 34,
    },
    fill: {
      type: String,
      default: "#8D5185",
    },
  },
};
</script>

<style lang="scss" scoped></style>
